module.exports = __webpack_public_path__ + "static/media/Fitness-Park.b494af1b.png";